export function transformLargeNumberList() {
    var largeNumberLists = document.querySelectorAll('ol.is-style-large-number');
    
    largeNumberLists.forEach(function(list) {
        var listItems = list.querySelectorAll('li');
        var startValue = parseInt(list.getAttribute('start')) || 1; // Get the start attribute value or default to 1
        
        listItems.forEach(function(item, index) {
            var number = startValue + index;
            var numberSpan = document.createElement('span');
            numberSpan.classList.add('list-number');
            numberSpan.innerText = number;
                
            item.insertBefore(numberSpan, item.firstChild); // Insert the span before the first child of the list item
        });
    });
}